export default {"src":"/_next/static/media/science.fe0c2580.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};